// extracted by mini-css-extract-plugin
module.exports = {"notification":"notification_notification__wsF2I","title":"notification_title__MBC2s"};